import type { ChainId } from '@/dex/types/main.types'
import { requireLib } from '@evm-ui/features/connect-wallet'
import type { ChainParams } from '@evm-ui/queries/query-types'
import { curveApiValidationSuite } from '@evm-ui/queries/validation/curve-api-validation'
import { queryFactory } from '@ui/features/queries/factory'

export const { useQuery: useAppStatsTvl } = queryFactory({
  queryKey: ({ chainId }: ChainParams<ChainId>) => ({ name: 'appStatsTvl', chainId }) as const,
  queryFn: (_: ChainParams<ChainId>) => requireLib('curveApi').getTVL(),
  validationSuite: curveApiValidationSuite,
  category: 'dex.appStats',
})
